<mat-card>
  <!-- El modal se abre desde el header del dashboard, que tapa el filtro: el
       rango se repite como subtítulo para que no haya dudas de a qué período
       corresponden los números. -->
  <app-card-header
    [title]="'Resumen del período'"
    [subtitle]="data.periodo"
    icono="fact_check"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <app-content-card title="Métricas" icon="query_stats">
      <app-metrica-help
        card-header-actions
        intro="Costo, convergencia y patologías del rango elegido en el dashboard. Para comparar dos corridas, se miran los dos rangos."
        [items]="data.help"
      />

      @if (data.filas.length) {
        <table class="rpd-tabla">
          <tbody>
            @for (f of data.filas; track f.label) {
              <tr [class.rpd-destacada]="f.destacado">
                <td class="rpd-label">
                  {{ f.label }}
                  @if (f.ayuda) {
                    <mat-icon class="rpd-ayuda" [matTooltip]="f.ayuda">
                      info
                    </mat-icon>
                  }
                </td>
                <td class="rpd-valor">
                  @if (f.valor) {
                    {{ f.valor }}
                  } @else {
                    <span class="no-info">Sin información</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <span class="no-info">Sin métricas de downlinks en el período.</span>
      }
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>
